<template>
  <div>
    <jazzicon class="avatar-icon" :address="address" :diameter="diameter" />
    <v-btn v-if="unread > 0 && !hideLastMessage" x-small fab outlined style="background-color: #FFFFFF; color:#00E3B4; position: absolute;bottom:20px; left: 45px; margin-top: 4%;">
      {{ unread }}
    </v-btn>
  </div>
</template>

<script>
import Jazzicon from 'vue-jazzicon';
export default {
    name: "Avatar",
    components: {
        [Jazzicon.name]: Jazzicon
    },
    props: {
        address: {type: String, default: null},
        diameter: {type: Number, default: 50},
        hideLastMessage: {type: Boolean, default: null},
        unread: {type: Number, default: null}
    },
    data: function () {
        return {
        };
    },
    methods: {
        goProfile () {
            if (this.$router.history.current.name !== "profile") {
                this.$router.push({name: 'profile', replace: true});
            }
        },
    },
};
</script>

<style scoped>
.avatar-icon {
  display: inline-block;
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 4;
  color: #ffffff;
  font-weight: bold;
  border-radius: 50%;
  margin-top: 10px;
}
</style>
